import { render } from "./CheckDecagram.vue?vue&type=template&id=5288bfd2"
import script from "./CheckDecagram.vue?vue&type=script&lang=js"
export * from "./CheckDecagram.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/CheckDecagram.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5288bfd2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5288bfd2', __exports__)) {
    api.reload('5288bfd2', __exports__)
  }
  
  module.hot.accept("./CheckDecagram.vue?vue&type=template&id=5288bfd2", () => {
    api.rerender('5288bfd2', render)
  })

}


export default __exports__